export function createMapeoErp() {
  return {
    ErpId: '',
    ObjetoId: 0,
    CampoGestion360: '',
    CampoErp: '',
    Transformacion: ''
  };
}
